import React from "react";
import {Helmet} from "react-helmet";
import Speech1 from "../../assets/images/data-ai-speech/DataAISpeech-0.jpg";
import Speech2 from "../../assets/images/data-ai-speech/DataAISpeech-00.jpg";
import Speech3 from "../../assets/images/data-ai-speech/DataAISpeech-1.jpg";
import Speech4 from "../../assets/images/data-ai-speech/DataAISpeech-2.jpg";
import Speech5 from "../../assets/images/data-ai-speech/DataAISpeech-3.jpg";
import Speech6 from "../../assets/images/data-ai-speech/DataAISpeech-4.jpg";
import Speech7 from "../../assets/images/data-ai-speech/DataAISpeech-5.jpg";
import Speech8 from "../../assets/images/data-ai-speech/DataAISpeech-6.jpg";
import Speech9 from "../../assets/images/data-ai-speech/DataAISpeech-7.jpg";
import Speech10 from "../../assets/images/data-ai-speech/DataAISpeech-8.jpg";
import Speech11 from "../../assets/images/data-ai-speech/DataAISpeech-9.png";
import Speech12 from "../../assets/images/data-ai-speech/DataAISpeech-10.jpg";
import Benchmark from "../../assets/images/data-ai-speech/benchmark.png";

export default function BatAndHorse() {
    return (
        <div>
            <Helmet>
                <title>旧金山 2024 Data+AI Summit 峰会演讲 DATA+AI Summit 2024 San Francisco</title>
            </Helmet>
            <h6 className="App-essay-title">旧金山 2024 Data+AI Summit 峰会演讲</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二四 六月</b>
                <br/><br/>
                2024年6月11日，我和腾讯同事贺欢在旧金山 Databricks Data+AI Summit做了一场演讲。
                <br/><br/>
                <b>有趣的是，腾讯在2024年6月份，就察觉过deepseek的威力（我们团队），ds有优异的benchmark体验。这是远早于硅谷的视角。</b>
                <br/><br/>
                <img src={Benchmark} alt="" width={"100%"}/> <br/><br/>
                多位专业听众结束后跟我们说，我们的session是本次summit听到最好的技术演讲，倍感荣幸。
                <br/><br/>
                <b>我们的成果是团队合作的结果，感谢团队和朋友们支持。</b>
                <br/><br/>
                <b>It is fun. Thanks TEAM!</b>
                <br/><br/>
                <img src={Speech2} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech1} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech3} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech4} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech5} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech6} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech7} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech8} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech9} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech10} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech12} alt="" width={"100%"}/> <br/><br/>
                <img src={Speech11} alt="" width={"100%"}/> <br/><br/><br/>

                <b>Reference:</b>
                <br/>
                <a href="https://www.youtube.com/watch?v=3zpnKC7IMQU">Bring Text-To-SQL To BI Production in Large Enterprise</a>
            </p>

            <br/>

            <h6 className="App-essay-title">DATA+AI Summit 2024 San Francisco</h6>
            <p className="App-essay-article">
                <br/>
                <b>Jun 2024</b>
                <br/><br/>

            </p>
        </div>)
}
